import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0c56a1c9")

_pushScopeId("data-v-0c56a1c9")
const _hoisted_1 = { class: "pt-4" }
const _hoisted_2 = { class: "flex flex-row justify-between" }
const _hoisted_3 = { class: "flex flex-row w-3/4" }
const _hoisted_4 = { class: "hal-table" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_FilterHal = _resolveComponent("FilterHal")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Detail = _resolveComponent("Detail")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Search, {
            placeholder: _ctx.$t('urgentDeliveryManagement.searchPlaceholder'),
            value: _ctx.parameters.search,
            onInput: _ctx.onSearch,
            onClear: _ctx.clearSearch,
            class: "w-300px"
          }, null, 8, ["placeholder", "value", "onInput", "onClear"]),
          _createVNode(_component_lp_button, {
            id: "btnSort",
            title: _ctx.$t('urgentDeliveryManagement.sortLatest'),
            icon: "sort-filter",
            textColor: _ctx.sortButtonStyle.textColor,
            customClass: _ctx.sortButtonStyle.customClass,
            color: _ctx.sortButtonStyle.color,
            outline: "",
            small: "",
            onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.parameters.onSort = !_ctx.parameters.onSort;
              _ctx.fetchList(true);
            }
          ),
            class: "w-300px"
          }, null, 8, ["title", "textColor", "customClass", "color"]),
          _createVNode(_component_FilterHal, {
            class: "ml-4",
            options: _ctx.lastLocationOptions,
            onApply: _ctx.onApplyFilter,
            onReset: _ctx.onResetFilter
          }, null, 8, ["options", "onApply", "onReset"])
        ]),
        _createVNode(_component_lp_button, {
          "icon-left": "download-new",
          title: _ctx.$t('urgentDeliveryManagement.download'),
          textColor: "red-lp-300",
          customClass: "w-44",
          outline: "",
          small: "",
          class: "right-0",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDownload()))
        }, null, 8, ["title"])
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.controller.HALList.length)
          ? (_openBlock(), _createBlock(_component_TableV2, {
              key: 0,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pagination = $event)),
              loading: _ctx.controller.isLoading,
              columns: _ctx.columns,
              data: _ctx.controller.HALList,
              paginationStyle: "v3",
              pinnedSubstractHeight: "300px",
              onRequest: _cache[4] || (_cache[4] = () => _ctx.fetchList()),
              onClick: _ctx.goToDetail,
              isDetailAble: ""
            }, null, 8, ["pagination", "loading", "columns", "data", "onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.controller.HALList.length)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 1,
              customHeaderMessage: _ctx.emptyStateData.headerMessage,
              customMessage: _ctx.emptyStateData.message,
              icon: _ctx.emptyStateData.icon
            }, null, 8, ["customHeaderMessage", "customMessage", "icon"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createVNode(_component_Detail, {
      data: _ctx.urgentDeliveryManagementDetailData,
      close: _ctx.closeDetail
    }, null, 8, ["data", "close"]), [
      [_vShow, _ctx.modalDetail]
    ])
  ], 64))
})